import { DashboardLayout } from 'components/layout/DashboardLayout';
import { useCustomSelector } from 'hooks';
import React, { useEffect, useState } from 'react';

import "assets/scss/billingPortal/modules/reporting/billingSetup.scss";
import { convertArrayToDropdownArrayFormat, isArrayNotEmpty, isNotNullUndefined, isNullUndefined, isObjectNotEmpty, isStringTrimNotEmpty } from 'functions';
import useReporting from 'dataflow/billingPortal/actions/useReporting.actions';
import { Dropdown } from 'components/filters/Dropdown';
import { COM_WITHOUT_BILLING_SETUP, COM_WITHOUT_BILLING_SETUP_AND_HAS_MISSING_OUTLET, COM_WITHOUT_DEFAULT_PRODUCT } from 'constants/billingSetupReport';
import { Spinner } from 'components/loaders/Spinner';

export default function BillingSetupReport() {
    const {
        userPermissions
    } = useCustomSelector("userManagementReducers");
    
    const {
        getBillingSetupReport_requesting, billingSetupReport,
    } = useCustomSelector("reporting");

    const { 
        getBillingSetupReport, 
    } = useReporting();

    const [filterType, setFilterType] = useState(COM_WITHOUT_BILLING_SETUP);
    const [selectedCOM, setSelectedCOM] = useState();
    const [leftLabel, setLeftLabel] = useState("");
    const [leftList, setLeftList] = useState([]);
    const [rightLabel, setRightLabel] = useState("");
    const [rightList, setRightList] = useState([]);

    useEffect(() => {
        getBillingSetupReport(filterType);
        setSelectedCOM(undefined);
    }, [filterType]);

    useEffect(() => {
        let leftLabel = "", leftList = [];
        let rightLabel = "", rightList = [];
        switch (filterType) {
            case COM_WITHOUT_BILLING_SETUP: case COM_WITHOUT_DEFAULT_PRODUCT:
                if (isObjectNotEmpty(billingSetupReport)) {
                    for (let property in billingSetupReport) {
                        if (billingSetupReport?.[property]) {
                            if (leftLabel == "") {
                                leftLabel = property;
                                leftList = billingSetupReport?.[property];
                            }
                            else {
                                rightLabel = property;
                                rightList = billingSetupReport?.[property];
                            }
                        }
                    }
                }
                break;
            case COM_WITHOUT_BILLING_SETUP_AND_HAS_MISSING_OUTLET:
                leftLabel = "COMs";

                for (let property in billingSetupReport) {
                    if (billingSetupReport?.[property]) {
                        leftList.push(property);
                    }
                }
                rightLabel = "Outlets under COM " + selectedCOM;
                rightList = billingSetupReport?.[selectedCOM + ""]? billingSetupReport?.[selectedCOM + ""].map((obj) => {
                    return (
                        <>
                            <div><div className={"item__label"}>ID</div>: {obj?.OutletId}</div>
                            <div><div className={"item__label"}>Name</div>: {obj?.OutletName}</div>
                        </>
                    )
                }):[];
                break;
        }

        setLeftLabel(leftLabel);
        setLeftList(leftList);
        setRightLabel(rightLabel);
        setRightList(rightList);
    }, [billingSetupReport, selectedCOM]);

    return (
        <DashboardLayout
            headerTitle={"Billing Setup Report"}

            bodyClassName={"billing-setup-report"}
            body={(
                <>
                    <div className={"billing-setup-report__headers"}>
                        {/* Top Section */}
                        <div className={"headers__top-section d-flex justify-content-between align-items-center"}>
                            {/* Title */}
                            <div className={"headers__title tableHeaderTitle "}>
                                COM List
                            </div>
                        </div>

                        {/* Bottom Section */}
                        <div className={"headers__bottom-section"}>
                            <Dropdown
                                className={"bottom-section__filters"}
                                selectedValueClassName={"filters__input"}
                                isDisabled={!(userPermissions?.Internal_UsageBillingReport_View)}

                                label={"Billing Report Type"}
                                options={convertArrayToDropdownArrayFormat([
                                    "Not in Billing Setup",
                                    "Not Default Product",
                                    "Not Default Product & Missing Outlets"
                                ])}
                                selectedValue_default={"Not in Billing Setup"}
                                onChange={(value) => {
                                    let type = "";
                                    switch (value) {
                                        case "Not in Billing Setup":
                                            type = COM_WITHOUT_BILLING_SETUP; break;
                                        case "Not Default Product":
                                            type = COM_WITHOUT_DEFAULT_PRODUCT; break;
                                        case "Not Default Product & Missing Outlets":
                                            type = COM_WITHOUT_BILLING_SETUP_AND_HAS_MISSING_OUTLET; break;
                                    }

                                    setFilterType(type);
                                }}
                            />
                        </div>
                    </div>

                    <div className={"billing-setup-report__content"}>
                        {/* Left Section */}
                        <div className={"content__left-section"}>
                            {/* Label */}
                            <div className={"left-section__label "}>{leftLabel}</div>

                            {/* List */}
                            <div className={"left-section__list"}>
                                {getBillingSetupReport_requesting? (
                                    // Loader
                                    <div className={"list__loader"}>
                                        <Spinner/>
                                    </div>
                                ): leftList.map((value, idx) => {
                                    return (
                                        <div key={idx} className={"list__item " + (filterType == COM_WITHOUT_BILLING_SETUP_AND_HAS_MISSING_OUTLET? "list__item_clickable ":"")}
                                            onClick={() => {
                                                if (filterType == COM_WITHOUT_BILLING_SETUP_AND_HAS_MISSING_OUTLET) {
                                                    setSelectedCOM(value);
                                                }
                                            }}
                                        >
                                            {value}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>

                        {/* Right Section */}
                        <div className={"content__right-section"}>
                                {/* Label */}
                            <div className={"right-section__label " + (isNullUndefined(selectedCOM) && (filterType == COM_WITHOUT_BILLING_SETUP_AND_HAS_MISSING_OUTLET)? "invisible":"")}>{rightLabel}</div>

                            {/* List */}
                            <div className={"right-section__list"}>
                                {getBillingSetupReport_requesting? (
                                    // Loader
                                    <div className={"list__loader"}>
                                        <Spinner/>
                                    </div>
                                ): isArrayNotEmpty(rightList)? rightList.map((value, idx) => {
                                    return (
                                        <div key={idx} className={"list__item"}>
                                            {value}
                                        </div>
                                    )
                                }): (
                                    <div className={"list__placeholder"}>
                                        Please select COM in the left box
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}
        />
    );
}